import { render, staticRenderFns } from "./ClinicHistoryModal.vue?vue&type=template&id=a01f0176&scoped=true"
import script from "./ClinicHistoryModal.vue?vue&type=script&lang=js"
export * from "./ClinicHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./ClinicHistoryModal.vue?vue&type=style&index=0&id=a01f0176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01f0176",
  null
  
)

export default component.exports